<template>
  <v-card title="人员维护">
        <v-modal
      title="提示信息"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
            
      <p>{{ message }}</p>
          </v-modal
    >
    <div class="grid-demo">
      <v-form slot="form">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="12">
            <div style="text-align: left">
              <v-form-item>
                <v-button type="success" icon="plus" @click="add('')"
                  ><span>添加</span></v-button
                >
              </v-form-item>
              <v-form-item>
                <v-button type="error"  @click="delsel()"
                  ><span>删除选中</span></v-button
                >
              </v-form-item>
              <v-form-item label="导入模板">
                <a href="../../../static/other/人员导入.xlsx"
                  >人员导入.xlsx</a
                >
              </v-form-item>
              <v-upload
                :action="action"
                :accept="xml"
                multiple
                @change="onChange"
              >
                <v-button type="ghost">
                  <v-icon type="upload"></v-icon>点击上传
                </v-button>
              </v-upload>
            </div>
          </v-col>
          <v-col class="gutter-row" span="12">
            <div style="text-align: right">
              <v-form-item>
                <v-input placeholder="输入工号或姓名" v-model="cx"></v-input>
              </v-form-item>
              <v-form-item>
                <v-button type="primary" icon="search" @click="findList('1')"
                  ><span>检索</span></v-button
                >
              </v-form-item>
              <v-form-item>
                <v-button type="warning" icon="export" @click="exportExcel()"
                  ><span>导出</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
      row-id="gh"
      @checkbox-change="checkboxChangeEvent"
      @checkbox-all="checkboxChangeEvent"
      @sort-change="sortChangeEvent"
    >
      <!--自定义插槽 cz-->
      <template v-slot:cz="{ row }">
        <span>
          <span>
            <a class="link" @click="add(row)" title="修改">
              <v-icon type="edit"></v-icon>
            </a>
            &nbsp;&nbsp;
            <v-popconfirm
              title="确定删除吗?"
              @confirm="del(row)"
              @cancel="cancel"
              placement="bottomRight"
            >
              <a class="link" title="删除">
                <v-icon type="delete"></v-icon>
              </a>
            </v-popconfirm>
            &nbsp;&nbsp;
            <v-popconfirm title="确定重置密码?" @confirm="reset(row)" @cancel="cancel" placement="bottomRight">
              <a class="link" title="重置密码">
                <v-icon type="reload"></v-icon>
              </a>
            </v-popconfirm>
          </span>
        </span>
      </template>
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
     <vxe-pager
       :current-page="pagination.pageindex"
      :page-size="pagination.pagesize"
      :total="pagination.totalresult"
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      @page-change="handlePageChange"
    ></vxe-pager>
  </v-card>
</template>
<script>
let options = {
  id: ""
};
let pagination = {
  sort: "gh",
  sorttype: "desc",
  pagesize: 10,
  pageindex: 1,
  totalresult: 1
};

export default {
  data() {
    return {
      options,
      pagination,
      checked: true,
      tableData: [],
      selectRecords: [],
      gh_list:[],
      visible: false,
      xml: ".xlsx",
      action: "api/system/rywh/upload-rywh-list",
      cx: "",
      message: "",
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 408,
        headerAlign: "center",
        checkboxConfig: {
          highlight: true,
          range: true,
          reserve: true,
        },
        editConfig: {
          trigger: "", //click可以编辑表格
          mode: "row",
          showStatus: true
        },
        columns: [
          { type: 'checkbox', width: 60,align: "center" },
          {
            field: "rn",
            title: "序号",
            width: 70,
            align: "center"
          },
          {
            field: "gh",
            title: "工号",
            align: "center",
            sortable: true,
          },
          {
            field: "xm",
            title: "姓名",
            align: "center",
            sortable: true,
          },
          {
            field: "sfzhm",
            title: "身份证号码",
            align: "center"
          },
          {
            field: "xb",
            title: "性别",
            align: "center",
            sortable: true,
            slots: {
              default: ({ row, column }) => {
                let xb = row.xb == 1 ? "男" : "女"
                if (row.xb == 1) {
                  xb = "男"
                } else if (row.xb == 2) {
                  xb = "女"
                } else {
                  xb = row.xb
                }
                return [
                  <span>{xb}</span>
                ];
              }
            }
          },
          {
            field: "mc",
            title: "地区",
            align: "center",
            sortable: true,
          },
          {
            field: "fzmc",
            title: "分组",
            align: "center"
          },
          {
            field: "rzrq",
            title: "入职日期",
            align: "center",
            sortable: true,
          },
          {
            field: "zw",
            title: "职位",
            align: "center",
            sortable: true,
          },
          {
            field: "lxdh",
            title: "联系电话",
            align: "center"
          },
          {
            field: "khmc",
            title: "入驻单位",
            align: "center",
            sortable: true,
          },
          {
            field: "lzrq",
            title: "离职日期",
            align: "center",
            sortable: true,
          },
          {
            field: "yhm",
            title: "用户名",
            align: "center",
            sortable: true,
          },
          {
            field: "dllx",
            title: "登入类型",
            align: "center",
            sortable: true,
            slots: {
              default: ({ row, column }) => {
                let dllx;
                if (row.dllx == 1) {
                  dllx = "全部"
                } else if (row.dllx == 2) {
                  dllx = "小程序"
                } else if (row.dllx == 3) {
                  dllx = "web端"
                } else {
                  dllx = row.dllx
                }
                return [
                  <span>{dllx}</span>
                ];
              }
            }
          },
          {
            field: "xybz",
            title: "状态",
            align: "center",
            sortable: true,
            slots: {
              default: ({ row, column }) => {
                let xybz = row.xybz == 1 ? "启用" : "禁用"
                return [
                  <span>{xybz}</span>
                ];
              }
            }
          },
          {
            field: "cz",
            title: "操作",
            align: "center",
            slots: {
              // 对应自定义插槽的名称
              default: "cz"
            }
          }
        ]
      }
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList(index) {
      if (index == "1"){
        this.pagination.pageindex = 1;
      }
      this.$axios
        .get(
          "api/system/rywh/get-rywh-list?cx=" + this.cx,{ params: this.pagination }
        )
        .then(res => {
          this.tableData = res.data.data
          this.pagination.totalresult = res.data.total;
        });
    },
    add: function (row) {
      let gh = row == "" ? "" : row.gh;
      let title = row == "" ? "添加人员" : "修改人员";
      xadmin.open(title, "/rywhadd?gh=" + gh, "600", "500","",this.findList);
    },
    exportExcel() {
      let a = document.createElement("a");
      a.href = "api/system/rywh/人员导出?cx=" + this.cx;
      a.click();
    },
    sortChangeEvent({ column, property, order }) {
      (this.pagination.sort= property), (this.pagination.sorttype = order);
      this.findList();
    },
    del: function (row) {
      this.$axios
        .get("api/system/rywh/del-rywh-list?gh=" + row.gh)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message["success"](res.data.message);
            this.findList();
          } else {
            this.$message["error"](res.data.message);
          }
        });
    },
    delsel:function(){
      let re_list=[]
      console.log(this.gh_list);
      this.gh_list.forEach(re => {debugger;
        if(re.record.length>0){
           re_list.push(re.record["gh"])
        }
         
      });
      if (re_list.length == 0){
        this.$message["error"]("请勾选删除人员！");
        return;
      }
      this.$axios
        .post("api/system/rywh/del-rywh-sellist" , this.gh_list)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message["success"](res.data.message);
            window.location.reload();
            // this.gh_list = [];
            // this.findList();
          } else {
            this.$message["error"](res.data.message);
          }
        });
    },
    reset:function(row){
      this.$axios
        .get("api/system/rywh/get-rywh-reset?gh=" + row.gh+"&sfzhm="+row.sfzhm)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message["success"](res.data.message);
            this.findList();
          } else {
            this.$message["error"](res.data.message);
          }
        });
    },
    cancel: function () {
      this.$message.info("取消删除");
    },
    handlePageChange({ currentPage, pageSize }) {
      this.pagination.pageindex = currentPage;
      this.pagination.pagesize = pageSize;
      this.findList();
    },
    onChange(info) {
      if (info.file.response) {
        if(info.file.response.code == "200"){
          //this.$message['success'](info.file.response.message);
          this.message = info.file.response.message;
          this.showModal();
          this.findList();
        }
        else {
          this.message = info.file.response.message;
          this.showModal();
      }
      } 
    },
    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
    },
    handleCancel() {
      this.visible = false;
    },
    checkboxChangeEvent({ checked,row,records }) {
      let self = this;
      this.isAllChecked = this.$refs.xTable.isAllCheckboxChecked()
      this.isIndeterminate = this.$refs.xTable.isCheckboxIndeterminate()
      let gh_options = {
        page:"",
        record:[]
      };
      
      gh_options.page = this.pagination.pageindex;
      records.forEach(rec => {
        gh_options.record.push(rec["gh"])
      });
      if(this.gh_list.length>0){
        let pagelist = []
        this.gh_list.forEach(ls => {
          pagelist.push(ls.page);
          if(ls.page == gh_options.page){
            ls.record = gh_options.record;
          }
        });
        if(pagelist.indexOf(gh_options.page)<0){
          this.gh_list.push(gh_options);
        }
      }else{
        this.gh_list.push(gh_options);
      }
      // console.log(checked)
      // console.log(row)
      // console.log(records)
      // if(checked){
      //   this.selectRecords.push(row["gh"])
      // }else{
      //   this.selectRecords.deleteElementByValue(row["gh"])
      // }
      // console.log(this.selectRecords);
    },
  }
};
Array.prototype.deleteElementByValue = function(varElement)
{
    var numDeleteIndex = -1;
    for (var i=0; i<this.length; i++)
    {
        // 严格比较，即类型与数值必须同时相等。
        if (this[i] === varElement)
        {
            this.splice(i, 1);
            numDeleteIndex = i;
            break;
        }
    }
    return numDeleteIndex;
}
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/jcsj/rywh.vue